// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { ProductActions, ProductActionTypes } from '../_actions/product.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { Product, ProductType, ProductVariety } from '../_models/product.model';

// tslint:disable-next-line:no-empty-interface
export interface ProductState extends EntityState<Product> {
    listLoading: boolean;
    actionsloading: boolean;
    totalCount: number;
    lastCreatedProductId: number;
    lastUpdatedProductId: number;
    lastDeletedProductId: number;
    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<Product> = createEntityAdapter<Product>();

export const initialProductState: ProductState = adapter.getInitialState({
    listLoading: false,
    actionsloading: false,
    totalCount: 0,
    lastQuery:  new QueryParamsModel({}),
    lastCreatedProductId: undefined,
    lastUpdatedProductId: undefined,
    lastDeletedProductId: undefined,
    showInitWaitingMessage: true
});

export function productsReducer(state = initialProductState, action: ProductActions): ProductState {
    switch  (action.type) {
        case ProductActionTypes.PRODUCT_ADDED: return adapter.addOne(action.payload.product, {
            ...state, lastCreatedProductId: action.payload.product.id
        });
        case ProductActionTypes.PRODUCT_EDITED: return adapter.updateOne(action.payload.partialProduct, 
            {...state, lastUpdatedProductId: action.payload.product.id});
        case ProductActionTypes.PRODUCT_PAGE_LOADED: return adapter.addMany(action.payload.products, {
            ...initialProductState,
            totalCount: action.payload.totalCount,
            lastQuery: action.payload.page,
            listLoading: false,
            showInitWaitingMessage: false
        });
        case ProductActionTypes.PRODUCT_ALL_LOADED: return adapter.addMany(action.payload.products, {
            ...initialProductState,
            listLoading: false,
            showInitWaitingMessage: false
        });
        case ProductActionTypes.PRODUCT_DELETED: return adapter.removeOne(action.payload.id, 
            {...state, lastDeletedProductId: action.payload.product.id});
        // case UserActionTypes.UsersPageCancelled: return {
        //     ...state, listLoading: false, lastQuery: new QueryParamsModel({})
        // };
        default: return state;
    }
}

export const getProductState = createFeatureSelector<ProductState>('products');

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();

//PRODUCT TYPES
export interface ProductTypeState{
    productTypes:ProductType[],
    productTypesLoaded:boolean;
}

export const initialProductTypeState: ProductTypeState = {
    productTypes: undefined,
    productTypesLoaded: false
}

export function productTypesReducer(state = initialProductTypeState, action: ProductActions):ProductTypeState{
    switch(action.type){
        case ProductActionTypes.PRODUCT_TYPES_LOADED:
            return {
                productTypesLoaded: true,
                productTypes: action.payload.productTypes
            };
        default:
            return state;
    }
}

//PRODUCT VARIETIES
export interface ProductVarietyState{
    productVarieties:ProductVariety,
    productVarietiesLoaded:boolean;
}

export const initialProductVarietyState: ProductVarietyState = {
    productVarieties: undefined,
    productVarietiesLoaded: false
}

export function productVarietiesReducer(state = initialProductVarietyState, action: ProductActions):ProductVarietyState{
    switch(action.type){
        case ProductActionTypes.PRODUCT_VARIETIES_LOADED:
            return {
                productVarietiesLoaded: true,
                productVarieties: action.payload.productVarieties
            };
        default:
            return state;
    }
}